import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
/**
 * 分页展示
 * @param  ele          要生成 pdf 的DOM元素（容器）
 * @param  padfName     PDF文件生成后的文件名字
 * */
// function downloadPDF(ele, pdfName){
//     let eleW = ele.offsetWidth;// 获得该容器的宽
//     let eleH = ele.offsetHeight;// 获得该容器的高
//     let eleOffsetTop = ele.offsetTop;  // 获得该容器到文档顶部的距离
//     let eleOffsetLeft = ele.offsetLeft; // 获得该容器到文档最左的距离

//     var canvas = document.createElement("canvas");
//     var abs = 0;

//     let win_in = document.documentElement.clientWidth || document.body.clientWidth; // 获得当前可视窗口的宽度（不包含滚动条）
//     let win_out = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）

//     if(win_out>win_in){
//         // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
//         abs = (win_out - win_in)/2;    // 获得滚动条宽度的一半
//     }
//     canvas.width = eleW * 2;    // 将画布宽&&高放大两倍
//     canvas.height = eleH * 2;

//     var context = canvas.getContext("2d");
//     context.scale(2, 2);
//     context.translate(-eleOffsetLeft -abs, -eleOffsetTop);
//     // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
//     // translate的时候，要把这个差值去掉
//     html2canvas( ele, {
//         dpi: 300,
//         // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
//         useCORS:true  //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
//     } ).then( (canvas)=>{
//         var contentWidth = canvas.width;
//         var contentHeight = canvas.height;
//         //一页pdf显示html页面生成的canvas高度;
//         var pageHeight = contentWidth / 592.28 * 841.89;
//         //未生成pdf的html页面高度
//         var leftHeight = contentHeight;
//         //页面偏移
//         var position = 0;
//         //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
//         var imgWidth = 595.28;
//         var imgHeight = 595.28/contentWidth * contentHeight;
//         var pageData = canvas.toDataURL('image/jpeg', 1.0);
//         var pdf = new JsPDF('', 'pt', 'a4');
//         //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
//         //当内容未超过pdf一页显示的范围，无需分页
//         if (leftHeight < pageHeight) {
//             //在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
//             pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
//             // pdf.addImage(pageData, 'JPEG', 20, 40, imgWidth, imgHeight);
//         } else {    // 分页
//             while(leftHeight > 0) {
//                 pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
//                 leftHeight -= pageHeight;
//                 position -= 841.89;
//                 //避免添加空白页
//                 if(leftHeight > 0) {
//                   pdf.addPage();
//                 }
//             }
//         }
//         //可动态生成
//         pdf.save(pdfName);

//     })
// }
/**
 * 不分页展示
 * @param  ele          要生成 pdf 的DOM元素（容器）
 * @param  padfName     p要成的pdfDomId
 * @param  name     名称
 * */
function downloadPDF(ele,pdfName,name){
  // 生成的pdf只有页面窗口可见的区域，有滚动条的下面没有生成出来，需在生成PDF前，改overflow属性auto为visible
	// 获取dom高度、宽度
	var shareContent = ele;
	var width = shareContent.offsetWidth / 4;
	var height = shareContent.offsetHeight / 4;
	// eslint-disable-next-line
	// let loadingInstance = Loading.service({text: '正在导出，请稍等'});
	html2canvas(pdfName, {
	// dpi: 900,
	dpi: window.devicePixelRatio*4, //将分辨率提高到特定的DPI 提高四倍
	// scale:4,//按比例增加分辨率
	allowTaint: true,
	taintTest: false,
	useCORS: true, //允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
	// backgroundColor: null //避免图片有白色边框
	}).then((canvas) => {
		var context = canvas.getContext('2d');
		context.mozImageSmoothingEnabled = false;
		context.webkitImageSmoothingEnabled = false;
		context.msImageSmoothingEnabled = false;
		context.imageSmoothingEnabled = false;
		var pageData = canvas.toDataURL('image/jpeg', 1.0);
		var img = new Image();
		img.src = pageData;
		img.onload = ()=> {
			// 获取dom高度、宽度
			img.width = img.width / 2;
			img.height = img.height / 2;
			img.style.transform = 'scale(0.5)';
			if (width > height) {
				// 此可以根据打印的大小进行自动调节
				// eslint-disable-next-line
				var pdf = new JsPDF('l', 'mm', [width * 0.505, height * 0.545]);
			} else {
				// eslint-disable-next-line
				var pdf = new JsPDF('p', 'mm', [width * 0.505, height * 0.545]);
			}
			pdf.addImage(pageData, 'jpeg', 0, 0, width * 0.505, height * 0.545);
			pdf.save(name  + '.pdf');
			// loadingInstance.close();
		};
	});
}

export default {
  downloadPDF
}

